module.exports = __webpack_public_path__ + "img/Elements_Selected.780e90d2.svg";